export const logo = {
  stibee: {
    src: '/images/stibee_logo.png',
    alt: 'Stibee, 스티비 로고',
    width: 86,
    height: 19,
  },
  mailchimp: {
    src: '/images/mailchimp_logo.png',
    alt: 'Mailchimp, 메일침프 로고',
    width: 68,
    height: 17,
  },
  gmail: {
    src: '/images/gmail_logo.png',
    alt: 'Gmail, 지메일 로고',
    width: 23,
    height: 17,
  },
  gmailWithText: {
    src: '/images/gmail_logo_with_text.png',
    alt: 'Gmail, 지메일 로고',
    width: 90,
    height: 19,
  },
  activeCampaign: {
    src: '/images/activeCampaign_logo.png',
    alt: 'ActiveCampaign, 액티브캠페인 로고',
    width: 168,
    height: 17,
  },
  totle: {
    src: '/images/totle_logo.png',
    alt: 'totle, 토틀 로고',
    width: 57,
    height: 19,
  },
  hubspot: {
    src: '/images/hubspot_logo.png',
    alt: 'Hubspot, 허브스팟 로고',
    width: 66,
    height: 19,
  },
  salesforcePardot: {
    src: '/images/salesforcePardot_logo.png',
    alt: 'Salesforce Pardot, 솔레스포스 파드트 로고',
    width: 120,
    height: 46,
  },
} as const;

export const logos = [
  [logo.stibee, logo.mailchimp, logo.gmail],
  [logo.activeCampaign, logo.hubspot],
] as const;
